import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md"
  }, [_c('div', {
    staticClass: "md_toolbar"
  }, [_c('div', {
    staticClass: "md_group"
  }, [_c('b-button', {
    staticClass: "md_btn md_btn--primary",
    attrs: {
      "size": "sm",
      "disabled": !_vm.siteCode
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" 新增 ")]), _vm.canSuggest ? _c('b-button', {
    staticClass: "md_btn",
    attrs: {
      "size": "sm",
      "disabled": !_vm.siteCode || _vm.suggesting,
      "title": _vm.isTopology ? '依監控資料自動建立 INV 與串列節點' : '依拓撲階層的節點與監控資料，推算各節點的標準電壓'
    },
    on: {
      "click": function click($event) {
        return _vm.openSuggest();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic",
    class: {
      'fa-spin': _vm.suggesting
    }
  }), _vm._v(" 由遙測產生 ")]) : _vm._e(), _vm.isVoltage ? _c('b-button', {
    staticClass: "md_btn",
    attrs: {
      "size": "sm",
      "disabled": !_vm.siteCode || _vm.suggesting,
      "title": "依 MPPT串列對應的分組建立 MPPT 節點，並產生其標準電壓"
    },
    on: {
      "click": function click($event) {
        return _vm.openSuggest('mppt');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-project-diagram",
    class: {
      'fa-spin': _vm.suggesting
    }
  }), _vm._v(" 由MPPT串列對應產生 ")]) : _vm._e(), _vm._t("actions")], 2), _c('span', {
    staticClass: "md_divider"
  }), _c('div', {
    staticClass: "md_group"
  }, [_c('b-button', {
    staticClass: "md_btn",
    attrs: {
      "size": "sm",
      "disabled": !_vm.selected.length,
      "title": "選好的列，指定欄位一次填成同一個值"
    },
    on: {
      "click": _vm.openBulk
    }
  }, [_c('i', {
    staticClass: "fas fa-fill-drip"
  }), _vm._v(" 一鍵填入 ")]), _c('b-button', {
    staticClass: "md_btn md_btn--danger",
    attrs: {
      "size": "sm",
      "disabled": !_vm.selected.length
    },
    on: {
      "click": _vm.removeSelected
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v(" 刪除 ")])], 1), _c('div', {
    staticClass: "md_group md_group--end"
  }, [_c('span', {
    staticClass: "md_stamp",
    attrs: {
      "title": "按住左鍵往上下拖曳可圈選多列；Shift 點選頭尾選中間全部；Ctrl／⌘ 點選單獨加減一列"
    }
  }, [_vm._v(" 共 " + _vm._s(_vm.rows.length) + " 列"), _vm.selected.length ? [_vm._v("，已選 " + _vm._s(_vm.selected.length) + " 列")] : _vm._e()], 2), _c('div', {
    staticClass: "md_search"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _c('b-form-input', {
    staticClass: "md_filter",
    attrs: {
      "size": "sm",
      "placeholder": "搜尋節點編號、名稱"
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1), _c('b-button', {
    staticClass: "md_btn md_btn--icon",
    attrs: {
      "size": "sm",
      "disabled": _vm.loading,
      "title": "重新整理",
      "aria-label": "重新整理"
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  })])], 1)]), _vm.error ? _c('b-alert', {
    staticClass: "mx-1 my-2 py-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-1"
  }), _vm._v(_vm._s(_vm.error) + " ")]) : _vm._e(), _c('b-alert', {
    staticClass: "mx-1 my-2 py-2",
    attrs: {
      "show": !_vm.siteCode,
      "variant": "secondary"
    }
  }, [_vm._v(" 先在上面選一個案場。 ")]), _c('b-table', {
    ref: "tbl",
    staticClass: "md_table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "filter": _vm.filter,
      "busy": _vm.loading,
      "tbody-tr-class": _vm.rowClass,
      "small": "",
      "hover": "",
      "bordered": "",
      "responsive": "",
      "sticky-header": "60vh",
      "show-empty": "",
      "empty-text": "這個案場還沒有資料，按「新增」開始建。",
      "empty-filtered-text": "沒有符合過濾條件的列。"
    },
    on: {
      "row-clicked": _vm.onRowClicked,
      "row-hovered": _vm.onRowHovered,
      "row-unhovered": function rowUnhovered($event) {
        _vm.hoverIndex = null;
      },
      "filtered": function filtered($event) {
        _vm.filteredRows = $event;
      }
    },
    nativeOn: {
      "mousedown": function mousedown($event) {
        return _vm.onMouseDown.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm.hasTotals && _vm.rows.length ? {
      key: "custom-foot",
      fn: function fn() {
        return [_c('b-tr', {
          staticClass: "md_total"
        }, [_c('b-th', {
          staticClass: "md_total_label",
          class: {
            'md_total_label--scoped': _vm.selected.length
          },
          attrs: {
            "sticky-column": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.totalLabel) + " ")]), _vm._l(_vm.def.columns, function (c) {
          return _c('b-td', {
            key: c.name
          }, [_vm.totals[c.name] ? [_vm._v(" " + _vm._s(_vm.totals[c.name].text) + " "), _vm.totals[c.name].missing ? _c('span', {
            staticClass: "md_total_missing",
            attrs: {
              "title": "".concat(_vm.totals[c.name].missing, " \u5217\u6C92\u586B\uFF0C\u6C92\u7B97\u9032\u5408\u8A08")
            }
          }, [_vm._v("缺 " + _vm._s(_vm.totals[c.name].missing))]) : _vm._e()] : _vm._e()], 2);
        })], 2)];
      },
      proxy: true
    } : null, {
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-3"
        }, [_c('b-spinner', {
          attrs: {
            "variant": "secondary"
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(_actions)",
      fn: function fn(row) {
        return [!row.item._placeholder ? _c('b-button', {
          staticClass: "py-0",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.openEdit(row.item);
            }
          }
        }, [_vm._v(" 編輯 ")]) : _vm._e()];
      }
    }], null, true)
  }), _c('b-modal', {
    attrs: {
      "title": _vm.editing ? "\u7DE8\u8F2F ".concat(_vm.rowLabel(_vm.form)) : "\u65B0\u589E\u4E00\u5217\uFF08".concat(_vm.def.label, "\uFF09"),
      "size": "lg",
      "scrollable": "",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formOpen,
      callback: function callback($$v) {
        _vm.formOpen = $$v;
      },
      expression: "formOpen"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": !_vm.lastSaved,
      "title": "把上一筆存過的內容，除了節點編號以外都帶過來"
    },
    on: {
      "click": _vm.fillFromLast
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-double-down"
  }), _vm._v(" 帶入上一筆 ")]), _c('span', {
    staticClass: "md_hint ml-2"
  }, [_vm._v(" 常填同一個值的欄位（案場代號、層級、上游節點…）會一起帶過來，節點編號不會。 ")])], 1), _vm._l(_vm.formColumns, function (c) {
    return _c('b-form-group', {
      key: c.name,
      staticClass: "mb-2",
      attrs: {
        "label": c.label + (c.required && (c.pk || !_vm.formUnwired) ? ' *' : ''),
        "description": c.hint,
        "label-cols-md": "3",
        "label-size": "sm"
      }
    }, [c.type === 'enum' ? _c('b-form-select', {
      attrs: {
        "options": [{
          value: null,
          text: '（未選）'
        }].concat(_toConsumableArray(c.options)),
        "size": "sm",
        "disabled": _vm.editing && c.pk
      },
      model: {
        value: _vm.form[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.form, c.name, $$v);
        },
        expression: "form[c.name]"
      }
    }) : c.type === 'bool' ? _c('b-form-checkbox', {
      attrs: {
        "switch": ""
      },
      model: {
        value: _vm.form[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.form, c.name, $$v);
        },
        expression: "form[c.name]"
      }
    }, [_vm._v(" " + _vm._s(_vm.form[c.name] ? '是' : '否') + " ")]) : c.blank ? _c('b-input-group', {
      attrs: {
        "size": "sm"
      }
    }, [_c('b-form-input', {
      attrs: {
        "maxlength": c.maxLength,
        "placeholder": "".concat(c.blank, "\uFF08\u672A\u63A5\u7DDA\uFF09")
      },
      on: {
        "input": function input($event) {
          return _vm.onFormInput(c);
        }
      },
      model: {
        value: _vm.form[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.form, c.name, $$v);
        },
        expression: "form[c.name]"
      }
    }), _c('b-input-group-append', [_c('b-button', {
      attrs: {
        "variant": _vm.form[c.name] ? 'outline-secondary' : 'secondary',
        "pressed": !_vm.form[c.name],
        "title": _vm.form[c.name] ? "\u6E05\u7A7A".concat(c.label, "\uFF0C\u6A19\u6210").concat(c.blank) : "\u53D6\u6D88".concat(c.blank, "\uFF0C\u9084\u539F").concat(c.label)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleBlank(c);
        }
      }
    }, [_vm._v(_vm._s(c.blank))])], 1)], 1) : _c('b-form-input', {
      attrs: {
        "size": "sm",
        "type": _vm.inputType(c),
        "step": c.type === 'int' ? 1 : 'any',
        "maxlength": c.maxLength,
        "disabled": _vm.editing && c.pk,
        "placeholder": _vm.editing && c.pk ? '主鍵不可修改，要改請刪掉重建' : ''
      },
      on: {
        "input": function input($event) {
          return _vm.onFormInput(c);
        }
      },
      model: {
        value: _vm.form[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.form, c.name, $$v);
        },
        expression: "form[c.name]"
      }
    })], 1);
  }), _vm.formError ? _c('b-alert', {
    staticClass: "py-2 mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.formError) + " ")]) : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "title": "\u4E00\u9375\u586B\u5165\uFF08\u5DF2\u9078 ".concat(_vm.selected.length, " \u5217\uFF09"),
      "ok-title": "填入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.bulkColumn
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.applyBulk.apply(null, arguments);
      }
    },
    model: {
      value: _vm.bulkOpen,
      callback: function callback($$v) {
        _vm.bulkOpen = $$v;
      },
      expression: "bulkOpen"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "要填哪個欄位",
      "label-size": "sm"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.bulkColumnOptions,
      "size": "sm"
    },
    model: {
      value: _vm.bulkColumn,
      callback: function callback($$v) {
        _vm.bulkColumn = $$v;
      },
      expression: "bulkColumn"
    }
  })], 1), _vm.bulkCol ? _c('b-form-group', {
    attrs: {
      "label": "\u586B\u4EC0\u9EBC\u503C",
      "description": _vm.bulkCol.hint,
      "label-size": "sm"
    }
  }, [_vm.bulkCol.type === 'enum' ? _c('b-form-select', {
    attrs: {
      "options": _vm.bulkCol.options,
      "size": "sm"
    },
    model: {
      value: _vm.bulkValue,
      callback: function callback($$v) {
        _vm.bulkValue = $$v;
      },
      expression: "bulkValue"
    }
  }) : _vm.bulkCol.type === 'bool' ? _c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.bulkValue,
      callback: function callback($$v) {
        _vm.bulkValue = $$v;
      },
      expression: "bulkValue"
    }
  }, [_vm._v(" " + _vm._s(_vm.bulkValue ? '是' : '否') + " ")]) : _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": _vm.inputType(_vm.bulkCol),
      "step": _vm.bulkCol.type === 'int' ? 1 : 'any',
      "maxlength": _vm.bulkCol.maxLength
    },
    model: {
      value: _vm.bulkValue,
      callback: function callback($$v) {
        _vm.bulkValue = $$v;
      },
      expression: "bulkValue"
    }
  }), !_vm.bulkCol.required ? _c('small', {
    staticClass: "md_hint"
  }, [_vm._v("留空 = 把這幾列的這個欄位清成空值。")]) : _vm._e()], 1) : _vm._e(), _vm.formError ? _c('b-alert', {
    staticClass: "py-2 mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "title": _vm.suggestTitle,
      "size": "xl",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.suggest.rows.length
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.applySuggest.apply(null, arguments);
      }
    },
    model: {
      value: _vm.suggestOpen,
      callback: function callback($$v) {
        _vm.suggestOpen = $$v;
      },
      expression: "suggestOpen"
    }
  }, [_c('div', {
    staticClass: "md_toolbar"
  }, [!_vm.fromMppt ? [_c('label', {
    staticClass: "md_hint mb-0"
  }, [_vm._v("取樣日期")]), _c('b-form-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "date",
      "size": "sm"
    },
    model: {
      value: _vm.suggestDate,
      callback: function callback($$v) {
        _vm.suggestDate = $$v;
      },
      expression: "suggestDate"
    }
  })] : _vm._e(), !_vm.isTopology ? [_c('label', {
    staticClass: "md_hint mb-0 ml-2"
  }, [_vm._v("單片開路電壓 V")]), _c('b-form-input', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "type": "number",
      "step": "any",
      "size": "sm",
      "placeholder": "48"
    },
    model: {
      value: _vm.moduleVoc,
      callback: function callback($$v) {
        _vm.moduleVoc = $$v;
      },
      expression: "moduleVoc"
    }
  }), _c('label', {
    staticClass: "md_hint mb-0"
  }, [_vm._v("串接片數")]), _c('b-form-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "step": "1",
      "size": "sm",
      "placeholder": "18"
    },
    model: {
      value: _vm.moduleCount,
      callback: function callback($$v) {
        _vm.moduleCount = $$v;
      },
      expression: "moduleCount"
    }
  })] : _vm._e(), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "disabled": _vm.suggesting || _vm.fromMppt && !_vm.hasModuleSpec
    },
    on: {
      "click": _vm.fetchSuggest
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.suggesting
    }
  }), _vm._v(" " + _vm._s(_vm.fromMppt ? '重算' : '重新取樣') + " ")]), _vm.suggest.rows.length ? _c('span', {
    staticClass: "md_stamp"
  }, [_vm.fromMppt ? [_vm._v(" MPPT串列對應共 " + _vm._s(_vm.suggest.samples) + " 列 → " + _vm._s(_vm.suggest.rows.length) + " 個 MPPT ")] : [_vm._v(" " + _vm._s(_vm.suggest.date) + " 白天 " + _vm._s(_vm.suggest.samples) + " 筆遙測 "), _vm.suggest.source ? [_vm._v("（來自外部監控 " + _vm._s(_vm.suggest.source) + "）")] : _vm._e(), _vm._v(" → "), _vm.isTopology ? [_vm._v(_vm._s(_vm.suggest.inv) + " 台 INV、" + _vm._s(_vm.suggest.str) + " 串，")] : _vm._e(), _vm._v(" 共 " + _vm._s(_vm.suggest.rows.length) + " 列 ")]], 2) : _vm._e()], 2), _vm.fromMppt && !_vm.hasModuleSpec ? _c('b-alert', {
    staticClass: "py-2",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" 先把上面的"), _c('strong', [_vm._v("單片開路電壓")]), _vm._v("與"), _c('strong', [_vm._v("串接片數")]), _vm._v("填好，再按「重算」。 這兩個數值請參考模組規格書（例：單片開路電壓 48 V、每串 18 片）。 ")]) : _vm._e(), _vm.fromMppt ? _c('b-alert', {
    staticClass: "py-2 md_hint",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" 節點清單取自"), _c('strong', [_vm._v("「MPPT串列對應」")]), _vm._v("已建立的資料，不需要監控資料，案場離線時也能產生。 節點編號格式為 "), _c('code', [_vm._v("INV序號-MPPT編號")]), _vm._v("，電壓型態固定為 "), _c('code', [_vm._v("MPPT電壓")]), _vm._v("。 標準電壓 ＝ "), _c('strong', [_vm._v("單片開路電壓 × 串接片數")]), _vm._v("：同一 MPPT 下各串並聯、電壓相同，因此與串列電壓一致。 所有串列皆未接線的 MPPT "), _c('strong', [_vm._v("仍會建立")]), _vm._v("，並於備註標示。 已存在的節點會略過，不會覆蓋手動建立的內容。 ")]) : _vm.isTopology ? _c('b-alert', {
    staticClass: "py-2 md_hint",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" INV 台數與串列數依監控資料判讀；"), _c('strong', [_vm._v("沒有讀數的位置視為未接線，不建立節點")]), _vm._v("，因此陣列位置可能跳號。 串列節點編號取自"), _c('strong', [_vm._v("「MPPT串列對應」")]), _vm._v("（例 "), _c('code', [_vm._v("INV1-3-1")]), _vm._v("）； "), _c('strong', [_vm._v("若該分頁尚未建立，將改用 "), _c('code', [_vm._v("INV1-STR6")]), _vm._v(" 形式的暫時編號")]), _vm._v("，事後需重編，建議先完成該分頁。 系統只會自動填入串列的上游節點；INV 的上游（MV／LV 節點）請以「一鍵填入」補上。 已存在的節點會略過，不會覆蓋手動建立的內容。 ")]) : _c('b-alert', {
    staticClass: "py-2 md_hint",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" 節點清單取自"), _c('strong', [_vm._v("「拓撲階層」")]), _vm._v("已建立的節點。標準電壓的判定方式： "), _c('strong', [_vm._v("INV")]), _vm._v(" 取三相相電壓平均的中位數，"), _c('strong', [_vm._v("電錶")]), _vm._v("取線電壓的中位數， 再對應至最接近的標稱電壓（220／380／480／11400／22800／69000／161000 V）； 與標稱值差距超過 15% 的節點不自動判定，將列於下方略過清單。 "), _c('strong', [_vm._v("串列")]), _vm._v("無法由監控資料判定，標準電壓 ＝ 模組開路電壓 × 串接片數，請於上方填入後才會產生。 "), _c('strong', [_vm._v("MPPT")]), _vm._v(" 請改用「由MPPT串列對應產生」。 ")]), _vm.suggest.skipped && _vm.suggest.skipped.length ? _c('b-alert', {
    staticClass: "py-2 md_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('strong', [_vm._v("略過 " + _vm._s(_vm.suggest.skipped.length) + " 列")]), _vm._v("（這幾個節點推不出標準電壓，要自己建）： "), _c('div', {
    staticClass: "md_skipped"
  }, _vm._l(_vm.suggest.skipped, function (s) {
    return _c('div', {
      key: s.node_id
    }, [_vm._v(_vm._s(s.node_id) + " —— " + _vm._s(s.why))]);
  }), 0)]) : _vm._e(), _vm.suggest.rows.length ? _c('b-table', {
    staticClass: "md_table",
    attrs: {
      "items": _vm.suggest.rows,
      "fields": _vm.suggestFields,
      "small": "",
      "bordered": "",
      "responsive": "",
      "sticky-header": "45vh"
    }
  }) : _vm._e(), _vm.formError ? _c('b-alert', {
    staticClass: "py-2 mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };